export default {
	"order.CongratulationsOnYourSuccessfulPurchase": "Congratulations on your successful purchase",
	"order.TheCouponHasBeenPlacedInYourPersonalAccountYouCanLogInToTheCallAppOrAppletToViewIt": "The coupon has been placed in your personal account, you can log in to the [Call] App or applet to view it",
	"order.checkOrder": "check order",
	"order.LongPressOrScanTheQRCodeToIdentifyTheCallingApplet": "Long press or scan the QR code to identify the calling applet"
}